<script lang="ts" setup>
import { computed } from "vue";

import type { VuetifyDensity } from "#types/vuetify";

interface ErrorAlertProps {
  /**
   * Size dicates font size and density
   * - `small` - Dialogs or other small/dense UI
   * - `medium` - Default display
   * - `large` - Page-level errors
   */
  size?: "small" | "medium" | "large";
  text?: string;
  title?: string;
}

const props = withDefaults(defineProps<ErrorAlertProps>(), {
  size: "medium",
  text: undefined,
  title: undefined,
});

const alertClasses = computed(() => {
  let titleClass = "";
  let textClass = "";
  if (props.size === "small" || props.size === "medium") {
    titleClass = "text-subtitle-1";
    textClass = "text-body-2";
  }
  return {
    text: textClass,
    title: titleClass,
  };
});

const density = computed((): VuetifyDensity | undefined => {
  if (props.size === "small") {
    return "compact";
  } else if (props.size === "medium") {
    return "comfortable";
  }
  return undefined;
});
</script>

<template>
  <VAlert v-if="text || title" :class="alertClasses.text" :density="density" type="error">
    <VAlertTitle v-if="title" :class="alertClasses.title">{{ title }}</VAlertTitle>
    {{ text }}
  </VAlert>
</template>
